import { Divider, Tabs, Tab } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import ProjectFunctionsWorkflowHeader from "./ProjectFunctionsWorkflowHeader";
import ProjectProcedures from "./ProjectProcedures";
import ProjectsContext from "./ProjectsContext";
import ProjectWorkflowContainer from "./ProjectWorkflowContainer";
import ProceduresMain from '../procedures/ProceduresMain';
const Container = styled.div``;

const ProceduresContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  @media (max-width: 1300px) {
    justify-content: left;
  }
`;

const TabsContainer = styled.div`
  padding-bottom: 10px;
`;

const HiddenDiv = styled.div`
  visibility:hidden;
  height:0px;
`;

const ProceduresSubContainer = styled.div``;

/*const TabValues = {
  Corporate: "Enterprise",
  ProjectSpecific: "Project-Specific",
};*/

class ProjectFunctionDetails extends React.Component {
  static contextType = ProjectsContext;
 /* state = {
    tabsValue: TabValues.Corporate
  };*/
  renderWorkflowSection() {
    if (!this.context.projectWorkflowDialogOpen) {
      return null;
    }

    return (
      <Container>
        <ProjectWorkflowContainer />
      </Container>
    );
  }

  render() {
    const { selectedProject, selectedProjectFunction } = this.context;
    return (
      <div>
        <ProjectFunctionsWorkflowHeader />
        <Divider />
        {this.renderWorkflowSection()}
       {/* <ProceduresContainer>
          <ProceduresSubContainer>
            <TabsContainer>
              <Tabs
                value={this.state.tabsValue}
                indicatorColor="primary"
                textColor="primary"
                aria-label="disabled tabs example"
                onChange={(event, tabsValue) => this.setState({ tabsValue })}
              >
                <Tab label={TabValues.Corporate} value={TabValues.Corporate} />
                <Tab
                  label={TabValues.ProjectSpecific}
                  value={TabValues.ProjectSpecific}
                />
              </Tabs>
            </TabsContainer>
            {this.state.tabsValue === TabValues.ProjectSpecific ? <ProceduresMain isProjectSpecific /> : null}
            {this.state.tabsValue === TabValues.Corporate ? <ProceduresMain isProjectSpecificCorporate /> : null}
          </ProceduresSubContainer>
        </ProceduresContainer>*/}
      </div>
    );
  }
}
export default ProjectFunctionDetails;
